<template>
  <main class="main community_main" role="main">
    <div class="comm_head">
      <div class="comm_con">
        <div class="title">커뮤니티</div>
        <button class="my_btn" @click="goMyPage"></button>
      </div>
    </div>
    <div class="main_con">
      <div class="comm_contents">
        <div class="comm_top">
          <div class="comm_bnr">
            <div class="main_slide">
              <div>
                <Swiper :options="swiperOption" @click-slide="clickSlide">
                  <SwiperSlide
                    v-for="(item, index) in mainSlide"
                    :key="index"
                    class="slide_bnr_list pnt"
                  >
                    <div class="bnr">
                      <img
                        :src="require(`@/assets/front/images/${item.img}`)"
                        alt=""
                      />
                    </div>
                  </SwiperSlide>
                  <div class="swiper-pagination" slot="pagination"></div>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="comm_hot_issue">
          <div class="title">Today Hot Issue</div>
          <div class="hot_issue_list">
            <ul>
              <hotListItem
                :item="hotListBoard"
                :botView="true"
                :type="'free'"
              />
              <hotListItem
                :item="hotListKnohow"
                :botView="true"
                :type="'knowhow'"
              />
            </ul>
          </div>
        </div>
        <div class="comm_sec_line"></div> -->
        <div class="comm_board">
          <div class="board_top pnt" @click="goKnowhowList">
            <div class="board_title">
              <div class="title">퍼스 지식인</div>
              <div class="sub_title">
                휴대폰,인터넷 등 4천여 통신 전문가에게 질문해보세요!
              </div>
            </div>
            <div class="arrow">
              <img
                :src="require(`@/assets/front/images/new/ar_main_sec_w.png`)"
                alt=""
              />
            </div>
          </div>
          <div class="board_list">
            <ul>
              <boardListItem
                v-for="(item, index) in knowhowList"
                :key="index"
                :item="item"
                :type="'knowhow'"
              />
            </ul>
          </div>
        </div>
        <div class="comm_sec_line"></div>
        <div class="comm_board">
          <div class="board_top pnt" @click="goBoardList">
            <div class="board_title">
              <div class="title">자유게시판</div>
              <div class="sub_title">
                후기, 추천, 일상 등에 대해 자유롭게 이야기 해봐요!
              </div>
            </div>
            <div class="arrow">
              <img
                :src="require(`@/assets/front/images/new/ar_main_sec_w.png`)"
                alt=""
              />
            </div>
          </div>
          <div class="board_list">
            <ul>
              <boardListItem
                v-for="(item, index) in boardList"
                :key="index"
                :item="item"
                :type="'free'"
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
    <NewBookModal ref="newBookModal" @close="closeNewBookModal"></NewBookModal>
  </main>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
// Import Swiper styles
import 'swiper/swiper.scss';

import hotListItem from './components/HotListItem';
import boardListItem from './components/BoardListItem';

import {
  mapActions as communityMapActions,
  mapGetters as communityGetters,
} from '@common/store/modules/community';
import * as communityTypes from '@common/store/modules/community/types';
import NewBookModal from '@common/components/chat/modal/NewBookModal';

export default {
  name: 'Community.Main',
  components: {
    // hotListItem,
    boardListItem,
    Swiper,
    SwiperSlide,
    NewBookModal,
    // DesignPopup,
    // InfiniteLoading,
    // // ShopDetail,
    // SkeletonStoreItem,
  },
  data() {
    return {
      mainSlide: [
        {
          num: '1',
          link_type: 'link',
          link_name: 'Manual.Main',
          img: 'banner/main/banner_coun_01.png',
          params: { isTab: 'tab_1' },
        },
        {
          num: '2',
          link_type: 'link',
          link_name: 'Manual.Main',
          img: 'banner/main/banner_coun_02.png',
          params: { isTab: 'tab_2' },
        },
        {
          num: '3',
          link_type: 'link',
          link_name: 'Shop.List',
          img: 'banner/main/banner_coun_03.png',
        },
      ],
      swiperOption: {
        // slidesPerView: 1,
        spaceBetween: 1,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 500,
        pagination: {
          el: '.swiper-pagination',
        },
      },
      hotListBoard: {},
      hotListKnohow: {},
    };
  },
  async created() {
    await this.getBoardList();
    await this.getHotList();
    await this.getKnowhowList();
  },
  async mounted() {},
  computed: {
    ...communityGetters({
      boardList: communityTypes.FETCH_BOARD_LIST,
      hotList: communityTypes.FETCH_HOT_LIST,
      knowhowList: communityTypes.FETCH_KNOWHOW_LIST,
    }),
  },
  methods: {
    ...communityMapActions([
      communityTypes.FETCH_BOARD_LIST,
      communityTypes.FETCH_HOT_LIST,
      communityTypes.FETCH_KNOWHOW_LIST,
    ]),
    async getBoardList() {
      const params = {
        page: 1,
        size: 2,
        myPost: 'N',
        orderType: 'CREATED_AT_DESC',
      };
      await this[communityTypes.FETCH_BOARD_LIST](params);
    },
    async getHotList() {
      const params = {
        category: '', // (MOBILE : 휴대폰, INTERNET : 인터넷) 빈값인 경우 랜덤
        type: 'ALL', // (KNOWHOW: 지식인, BOARD : 자유게시판, ALL : 모두)
      };
      await this[communityTypes.FETCH_HOT_LIST](params).then(() => {
        this.hotListBoard = this.hotList.boards[0];
        this.hotListKnohow = this.hotList.knowhows[0];
      });
    },
    async getKnowhowList() {
      const params = {
        page: 1,
        size: 4,
        myPost: '',
        category: '',
        keyword: '',
        orderType: 'CREATED_AT_DESC',
      };
      await this[communityTypes.FETCH_KNOWHOW_LIST](params);
    },
    goMyPage() {
      this.$router.push({ name: 'MyPage.Main' });
    },
    goBoardList() {
      this.$router.push({ name: 'Board.List' });
    },
    goKnowhowList() {
      this.$router.push({ name: 'Knowhow.List' });
    },
    goManual(name, params) {
      console.log('goManual');
      console.log(name);
      console.log(params);
      this.$router.push({
        name: name,
        params: params,
      });
    },
    goShopList(name) {
      this.$router.push({
        name: name,
      });
    },
    // swiper 안에 onclick 사용 하면 duplication 되어있는 영역은 onclick 가 안됨..ㅠㅠ  아래 방법으로 처리
    clickSlide(index, reallyIndex) {
      console.log('index : ' + index + ' : reallyIndex : ' + reallyIndex);
      if (reallyIndex == 0) {
        this.goManual(
          this.mainSlide[reallyIndex].link_name,
          this.mainSlide[reallyIndex].params,
        );
      } else if (reallyIndex == 1) {
        this.goManual(
          this.mainSlide[reallyIndex].link_name,
          this.mainSlide[reallyIndex].params,
        );
      } else if (reallyIndex == 2) {
        this.goShopList(this.mainSlide[reallyIndex].link_name);
      }
      // if (reallyIndex == 0 || reallyIndex == 1) {
      //   // this.openNewBookModal();
      //   this.noticeLink(this.mainSlide[reallyIndex].num);
      // } else if (reallyIndex == 2) {
      //   this.goManual(
      //     this.mainSlide[reallyIndex].link_name,
      //     this.mainSlide[reallyIndex].params,
      //   );
      // } else if (reallyIndex == 3) {
      //   this.goManual(
      //     this.mainSlide[reallyIndex].link_name,
      //     this.mainSlide[reallyIndex].params,
      //   );
      // } else if (reallyIndex == 4) {
      //   this.goShopList(this.mainSlide[reallyIndex].link_name);
      // }
    },
    // 사전예약 열기 (hsh)
    openNewBookModal() {
      this.$refs.newBookModal.isOpen = true;
      this.$refs.newBookModal.isSendButton = false;
    },
    closeNewBookModal() {
      this.$refs.newBookModal.isOpen = false;
    },
    noticeLink(id) {
      this.$router.push({
        name: 'Notice.Article',
        params: { id: id },
      });
    },
  },
};
</script>
